<template>
  <div class="invoice-structure">
    <div class="invoice-structure--header">
      <span>Fatura</span>
    </div>
    <div class="invoice-structure--body">
      <div class="invoice-structure--body__left">
        <div class="first-card card">
          <div>
            <span class="card-title">Info</span>
            <span class="card-data">{{ invoice.titulo }}</span>
          </div>
          <div>
            <span class="card-title">{{ t['invoice-number'] }}</span>
            <span class="card-data">{{ 'INV-' + invoice.id }}</span>
          </div>
          <div>
            <span class="card-title">{{ t['invoice-date'] }}</span>
            <span class="card-data">{{ invoiceData }}</span>
          </div>
        </div>
        <div class="second-card card">
          <div>
            <span class="card-title">{{ t['label-para'] }}</span>
            <span class="card-data">{{ user.nome }}</span>
            <span>{{ this.removePrefix(user.username) }}</span>
          </div>
        </div>
        <div class="third-card card">
          <div class="third-card--top">
            <span class="card-title">{{ t['office_magic_funnel_plans_items'].toUpperCase() }}</span>
          </div>
          <hr>
          <div class="third-card--body">
            <div class="third-card--body__left">
              <div v-for="(a, i) in this.view.invoice.itens" :key="i">
                <span class="card-data">{{ t[a.titulo] }}</span>
              </div>
            </div>
          </div>
          <hr>
          <div class="third-card--footer">
            <div>
              <span class="card-title">{{ t.dns_total }}</span>
              <span class="card-data">{{ '$' + invoice.total + ',00' }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="invoice-structure--body__right">
        <div class="four-card card">
          <div class="four-card--top">
            <span class="card-title">{{ t.payment_info }}</span>
            <div class="card-box">
              <img src="/internacional/public/images/gateways/stripe.png">
            </div>
          </div>
        </div>
        <div class="five-card card">
          <div class="four-card--footer">
            <button id="customButton">{{ t.office_invoice_efetuar_pagamento }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "5-invoice-pay",
  props: {
    view: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      t: this.view['translation'],
      invoice: this.view['invoice'],
      user: this.view['user'],
      value: {
        month: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
        year: []
      },
      process: false,
    }
  },
  mounted() {
    this.setYearValues()
  },
  computed: {
    invoiceData() {
      var dataStringISO = new Date(`${this.invoice.criacao}`);
      let data = new Date();
      if (this.view.lang == 'br') {
        data = (( dataStringISO.getDate().toString().padStart(2, "0") + "/" + (dataStringISO.getMonth() + 1).toString().padStart(2, "0") + "/" + dataStringISO.getFullYear()))
      } else {
        data = (((dataStringISO.getMonth() + 1).toString().padStart(2, "0") + "/" + dataStringISO.getDate().toString().padStart(2, "0") + "/" + dataStringISO.getFullYear()) + '\n')
      }
      return data
    }
  },
  methods: {
    setYearValues() {
      var currentYear = (new Date()).getFullYear();
      for (let i = 0; i <= 12; i++) {
        this.value.year.push(currentYear + i)
      }
    },
    removePrefix(email) {
      return sanitizePrefix(email)
    }
  }
};
</script>
<style scoped lang="scss">
@import '../../../../scss/wlStyles/_colors.scss';
.invoice-structure {
  width: 100%;
  height: auto;
  padding: 1.75rem 1rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 1.188rem;
  .invoice-structure--header {
    span {
      font-size: 1.5rem;
      font-weight: 700;
      color: var(--primary-color);
    }
  }
  .invoice-structure--body {
    width: 100%;
    height: auto;
    padding: 3.5rem;
    border-radius: 12px;
    background-color: #F9FBFB;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(30.875rem, 1fr));
    grid-auto-rows: auto;
    gap: 1rem 2.313rem;
    .invoice-structure--body__left {
      width: 100%;
      height: auto;
      min-height: 70px;
      grid-template-areas:
        "first-card"
        "second-card"
        "third-card"
        "third-card"
        "third-card"
        "third-card";
      .first-card {
        grid-area: first-card;
        display: inline-flex;
        justify-content: space-between;
      }
      .second-card {
        grid-area: second-card;
        max-height: 95px;
      }
      .third-card {
        grid-area: third-card;
        padding: 1rem 0 !important;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .third-card--top {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          padding: 0 1.8rem;
        }
        .third-card--body {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          padding: 0 1.8rem;
          .third-card--body__left {
            gap: .1em !important;
            div {
              gap: .1em !important;
            }
            .card-data {
              display: flex;
              flex-direction: column;
            }
          }
        }
        .third-card--footer {
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
          padding: 0 1.8rem;
          div {
            display: flex;
            flex-direction: row;
            gap: .8em
          }
        }
      }
    }
    .invoice-structure--body__right {
      width: 100%;
      height: auto;
      min-height: 70px;
      grid-template-areas:
        "four-card"
        "four-card"
        "four-card"
        "four-card"
        "five-card"
        "five-card";
      .four-card {
        grid-area: four-card;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .four-card--top {
          gap: 1rem !important;
          .card-box {
            width: 100%;
            height: 5rem;
            /*border: 1px solid var(--primary-color);*/
            background-color: #F7F7F7;
            border-radius: 10px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            gap: 2rem;
            img {
              width: 10rem;
            }
          }
        }
      }
      .five-card {
        grid-area: five-card;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        button {
          height: 3rem;
          background-color: var(--primary-color);
          border: 0 !important;
          border-radius: 4px;
          color: $white;
          -webkit-transition: background-color 700ms linear;
          -ms-transition: background-color 700ms linear;
          transition: background-color 700ms linear;
          z-index: 1;
          position: relative;
          border: none;
        }
        button::before {
          position: absolute;
          border-radius: 4px!important;
          z-index: -1;
          content: '';
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          transform: scaleX(0);
          transition: transform 5s ease-in-out;
          transform-origin: left;
          background-color: #0763cc;
        }
        button:focus::before {
          transform: scaleX(1);
        }
        button:disabled {
          background-color: $gray6;
        }
      }
    }
    .invoice-structure--body__right,
    .invoice-structure--body__left {
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: minmax(4.375rem, 1fr) minmax(4.375rem, 95px) repeat(4, minmax(4.375rem, 1fr));
      gap: 1rem;
      .card {
        width: 100%;
        height: 100%;
        background-color: $white;
        box-shadow: 1px 1px 3px $b-shadow1;
        border-radius: 10px;
        padding: 1rem 1.8rem;
        margin: 0 !important;
        div {
          display: flex;
          flex-direction: column;
          gap: .3rem;
        }
        span {
          font-family: 'Lato' !important;
        }
        .card-title {
          font-size: 1rem;
          color: $gray6;
        }
        .card-data {
          font-size: 1rem;
          color: $black1;
        }
      }
    }
  }
}
span {
  font-family: 'Muli';
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/invoice-pay/index.vue